// elements/theming/spacings.ts
import { ASS_PRIMITIVE } from "@adornis/ass/index.js";
var _a;
var Spacing = class _Spacing {
  constructor(value, unit = "px") {
    this[_a] = true;
    this._value = value;
    this._unit = unit;
  }
  static {
    _a = ASS_PRIMITIVE;
  }
  static make(value, unit = "px") {
    return new _Spacing(value, unit);
  }
  get number() {
    return this._value;
  }
  get string() {
    return `${this._value}${this._unit}`;
  }
  valueOf() {
    return this.number;
  }
  toString() {
    return this.string;
  }
};
export {
  Spacing
};
